import { EXPERIENCE_TABLE_REGISTRY } from './action-aware-table-registry.js';
const base = EXPERIENCE_TABLE_REGISTRY['table.investment.positionTransfers'];
if (!base)
    throw new Error('Missing canonical position-transfer table descriptor');
function cloneDisplayColumn(template, field, labelKey, overrides = {}) {
    return {
        ...template,
        id: `column.positionTransfer.${field}`,
        telemetryId: `experience.table.positionTransfer.${field}`,
        accessibilityLabelKey: labelKey,
        field,
        labelKey: labelKey,
        sortable: false,
        filterable: false,
        searchable: false,
        defaultVisible: true,
        requiredVisible: false,
        ...overrides,
    };
}
const sourceId = base.columns.find((column) => column.field === 'sourcePortfolioAccountId');
const destinationId = base.columns.find((column) => column.field === 'destinationPortfolioAccountId');
const reason = base.columns.find((column) => column.field === 'reason');
if (!sourceId || !destinationId || !reason) {
    throw new Error('Position-transfer table is missing required canonical source columns');
}
const sourceDisplay = cloneDisplayColumn(sourceId, 'sourcePortfolioAccountDisplay', 'card.positionTransfers.columns.source', { requiredVisible: true, defaultWidth: 220 });
const destinationDisplay = cloneDisplayColumn(destinationId, 'destinationPortfolioAccountDisplay', 'card.positionTransfers.columns.destination', { requiredVisible: true, defaultWidth: 220 });
const allocationCount = cloneDisplayColumn(reason, 'allocationCount', 'card.positionTransfers.columns.lots', { fieldType: 'number', align: 'right', defaultWidth: 100 });
const columns = [];
for (const column of base.columns) {
    columns.push(column);
    if (column.field === 'sourcePortfolioAccountId')
        columns.push(sourceDisplay);
    if (column.field === 'destinationPortfolioAccountId')
        columns.push(destinationDisplay);
    if (column.field === 'reason')
        columns.push(allocationCount);
}
/**
 * Effective contracts-owned table used by both the authenticated resolver and
 * the bespoke lifecycle page. Business-facing display columns live here so the
 * browser cannot invent or drift list structure independently of the backend
 * experience registry.
 */
export const EFFECTIVE_POSITION_TRANSFER_TABLE = Object.freeze({
    ...base,
    columns,
});
